<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Change VIVE status</h3>
    <p class="modal-subtitle mb-0">
      Update the vendor's VIVE status and log the reason in a note.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="CompanyVendorForm">
    <div class="row g-3">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" for="cs-status">VIVE status</label>
          <select
            id="cs-status"
            class="form-select"
            formControlName="viveStatus"
          >
            @for (viveStatus of ViveStatuses; track viveStatus) {
              <option [ngValue]="viveStatus">
                {{ viveStatus || '—' }}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label class="form-label" for="cs-sub-status">VIVE sub-status</label>
          <select
            id="cs-sub-status"
            class="form-select"
            formControlName="viveSubStatus"
          >
            @for (viveSubStatus of ViveSubStatuses; track viveSubStatus) {
              <option [ngValue]="viveSubStatus">
                {{ viveSubStatus || '—' }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </form>

  <div class="cs-section-head">
    <h4 class="mb-0">Note</h4>
    <p class="cs-section-sub mb-0">Required — explain what changed and why.</p>
  </div>

  <form [formGroup]="NoteForm">
    <div class="form-group">
      <label class="form-label" requiredAsterisk for="cs-note-title">
        Title
      </label>
      <input
        id="cs-note-title"
        type="text"
        class="form-control"
        formControlName="title"
        placeholder="Short summary of the change"
      />
    </div>

    <div class="form-group">
      <label class="form-label" requiredAsterisk for="cs-note-body">
        Note
      </label>
      <textarea
        id="cs-note-body"
        class="form-control cs-note-body"
        formControlName="note"
        rows="5"
        placeholder="Context, references, follow-up the next reviewer needs."
      ></textarea>
    </div>

    <div class="form-check cs-internal-toggle mb-0">
      <input
        id="cs-internal"
        type="checkbox"
        class="form-check-input"
        formControlName="isSensitive"
      />
      <label class="form-check-label" for="cs-internal">
        Internal note — hide from vendor and client
      </label>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      Save status
    </button>
  </div>
</div>
